import { render, staticRenderFns } from "./KommunetorgetSearchPage.vue?vue&type=template&id=52c632a2&"
import script from "./KommunetorgetSearchPage.vue?vue&type=script&lang=js&"
export * from "./KommunetorgetSearchPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\src\\KoRus.Kommunetorget\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52c632a2')) {
      api.createRecord('52c632a2', component.options)
    } else {
      api.reload('52c632a2', component.options)
    }
    module.hot.accept("./KommunetorgetSearchPage.vue?vue&type=template&id=52c632a2&", function () {
      api.rerender('52c632a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Assets/Scripts/components/pages/KommunetorgetSearchPage.vue"
export default component.exports